import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardPage} from '../pages/dashboard/DashboardWrapper'
import PreferencePage from '../pages/preference/PreferenceWrapper'
import MyPlacementPage from '../pages/myplacement/PlacementPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {DisableSidebar} from '../../_metronic/layout/core'
import {WithChildren} from '../../_metronic/helpers'
import {useAuth} from '../modules/auth'
const PrivateRoutes = () => {
  const {currentUser} = useAuth()
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const ModelListPage = lazy(() => import('../pages/modellist/Page'))
  const MethodListPage = lazy(() => import('../pages/methodlist/Page'))
  const RoleMethodListPage = lazy(() => import('../pages/rolemethodlist/Page'))
  const RoleModelListPage = lazy(() => import('../pages/rolemodellist/Page'))
  const MenuListPage = lazy(() => import('../pages/menulist/Page'))
  const MenuRolePage = lazy(() => import('../pages/menurole/Page'))
  const UserActionPage = lazy(() => import('../pages/useraction/Page'))
  const CulturePage = lazy(() => import('../pages/culture/Page'))
  const TranslationPage = lazy(() => import('../pages/translation/Page'))
  const ApplicationUserPage = lazy(() => import('../pages/applicationuser/Page'))
  const ApplicationRolePage = lazy(() => import('../pages/applicationrole/Page'))
  const ApplicationUserRolePage = lazy(() => import('../pages/applicationuserrole/Page'))
  const ApplicationUserClaimPage = lazy(() => import('../pages/applicationuserclaim/Page'))
  const ApplicationRoleClaimPage = lazy(() => import('../pages/applicationroleclaim/Page'))
  const TenantPage = lazy(() => import('../pages/tenant/Page'))
  const CodePage = lazy(() => import('../pages/code/Page'))
  const OrganizationPage = lazy(() => import('../pages/organization/Page'))
  const CountryPage = lazy(() => import('../pages/country/Page'))
  const TicketPage = lazy(() => import('../pages/ticket/Page'))
  const TicketReplyPage = lazy(() => import('../pages/ticketreply/Page'))
  const UserPreferencePage = lazy(() => import('../pages/userpreference/Page'))
  const UserResponsePage = lazy(() => import('../pages/userresponse/Page'))
  const OrganizationProgramPage = lazy(() => import('../pages/organizationprogram/Page'))
  const ProgramQuotaPage = lazy(() => import('../pages/programquota/Page'))
  const ExamResultPage = lazy(() => import('../pages/examresult/Page'))
  const ExamTypePage = lazy(() => import('../pages/examtype/Page'))
  const QuestionPage = lazy(() => import('../pages/question/Page'))
  const QuestionOptionPage = lazy(() => import('../pages/questionoption/Page'))
  const PreferencePeriodPage = lazy(() => import('../pages/preferenceperiod/Page'))
  const PlacementPage = lazy(() => import('../pages/placement/Page'))
  const PlacementLogPage = lazy(() => import('../pages/placementlog/Page'))
  const DiplomaAvarageTypePage = lazy(() => import('../pages/diplomaavaragetype/Page'))
  const AfePage = lazy(() => import('../pages/applicationforeignexam/Page'))
  const AnnouncementPage = lazy(() => import('../pages/announcement/Page'))
  const RegisterSettingPage = lazy(() => import('../pages/registersetting/Page'))
  const GuideSettingPage = lazy(() => import('../pages/guidesetting/Page'))
  const AcceptanceLetterEbysPage = lazy(() => import('../pages/acceptanceletterebys/Page'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/' />} />

        <Route path='dashboard' element={<DashboardPage />} />

        <Route path='preference' element={<PreferencePage />} />

        <Route
          path='myplacement'
          element={
            <SuspensedView>
              <MyPlacementPage />
            </SuspensedView>
          }
        />

        {currentUser?.roleName === 'ADMIN' && (
          <>
            <Route
              path='modellist/*'
              element={
                <SuspensedView>
                  <ModelListPage />
                </SuspensedView>
              }
            />
            <Route
              path='methodlist/*'
              element={
                <SuspensedView>
                  <MethodListPage />
                </SuspensedView>
              }
            />
            <Route
              path='rolemethodlist/*'
              element={
                <SuspensedView>
                  <RoleMethodListPage />
                </SuspensedView>
              }
            />
            <Route
              path='rolemodellist/*'
              element={
                <SuspensedView>
                  <RoleModelListPage />
                </SuspensedView>
              }
            />
            <Route
              path='menulist/*'
              element={
                <SuspensedView>
                  <MenuListPage />
                </SuspensedView>
              }
            />
            <Route
              path='menurole/*'
              element={
                <SuspensedView>
                  <MenuRolePage />
                </SuspensedView>
              }
            />
            <Route
              path='useraction/*'
              element={
                <SuspensedView>
                  <UserActionPage />
                </SuspensedView>
              }
            />
            <Route
              path='culture/*'
              element={
                <SuspensedView>
                  <CulturePage />
                </SuspensedView>
              }
            />
            <Route
              path='guidesetting/*'
              element={
                <SuspensedView>
                  <GuideSettingPage />
                </SuspensedView>
              }
            />

            <Route
              path='translation/*'
              element={
                <SuspensedView>
                  <TranslationPage />
                </SuspensedView>
              }
            />
            <Route
              path='applicationuser/*'
              element={
                <SuspensedView>
                  <ApplicationUserPage />
                </SuspensedView>
              }
            />
            <Route
              path='applicationrole/*'
              element={
                <SuspensedView>
                  <ApplicationRolePage />
                </SuspensedView>
              }
            />
            <Route
              path='applicationuserrole/*'
              element={
                <SuspensedView>
                  <ApplicationUserRolePage />
                </SuspensedView>
              }
            />
            <Route
              path='applicationuserclaim/*'
              element={
                <SuspensedView>
                  <ApplicationUserClaimPage />
                </SuspensedView>
              }
            />
            <Route
              path='applicationroleclaim/*'
              element={
                <SuspensedView>
                  <ApplicationRoleClaimPage />
                </SuspensedView>
              }
            />
            <Route
              path='tenant/*'
              element={
                <SuspensedView>
                  <TenantPage />
                </SuspensedView>
              }
            />
            <Route
              path='code/*'
              element={
                <SuspensedView>
                  <CodePage />
                </SuspensedView>
              }
            />
            <Route
              path='organization/*'
              element={
                <SuspensedView>
                  <OrganizationPage />
                </SuspensedView>
              }
            />
            <Route
              path='country/*'
              element={
                <SuspensedView>
                  <CountryPage />
                </SuspensedView>
              }
            />
            <Route
              path='ticket/*'
              element={
                <SuspensedView>
                  <TicketPage />
                </SuspensedView>
              }
            />
            <Route
              path='ticketreply/*'
              element={
                <SuspensedView>
                  <TicketReplyPage />
                </SuspensedView>
              }
            />
            <Route
              path='userpreference/*'
              element={
                <SuspensedView>
                  <UserPreferencePage />
                </SuspensedView>
              }
            />
            <Route
              path='userresponse/*'
              element={
                <SuspensedView>
                  <UserResponsePage />
                </SuspensedView>
              }
            />
            <Route
              path='organizationprogram/*'
              element={
                <SuspensedView>
                  <OrganizationProgramPage />
                </SuspensedView>
              }
            />
            <Route
              path='programquota/*'
              element={
                <SuspensedView>
                  <ProgramQuotaPage />
                </SuspensedView>
              }
            />
            <Route
              path='examresult/*'
              element={
                <SuspensedView>
                  <ExamResultPage />
                </SuspensedView>
              }
            />
            <Route
              path='examtype/*'
              element={
                <SuspensedView>
                  <ExamTypePage />
                </SuspensedView>
              }
            />
            <Route
              path='question/*'
              element={
                <SuspensedView>
                  <QuestionPage />
                </SuspensedView>
              }
            />
            <Route
              path='questionoption/*'
              element={
                <SuspensedView>
                  <QuestionOptionPage />
                </SuspensedView>
              }
            />
            <Route
              path='preferenceperiod/*'
              element={
                <SuspensedView>
                  <PreferencePeriodPage />
                </SuspensedView>
              }
            />
            <Route
              path='placement/*'
              element={
                <SuspensedView>
                  <PlacementPage />
                </SuspensedView>
              }
            />
            <Route
              path='placementlog/*'
              element={
                <SuspensedView>
                  <PlacementLogPage />
                </SuspensedView>
              }
            />

            <Route
              path='applicationforeignexam/*'
              element={
                <SuspensedView>
                  <AfePage />
                </SuspensedView>
              }
            />

            <Route
              path='diplomaavaragetype/*'
              element={
                <SuspensedView>
                  <DiplomaAvarageTypePage />
                </SuspensedView>
              }
            />
            <Route
              path='announcement/*'
              element={
                <SuspensedView>
                  <AnnouncementPage />
                </SuspensedView>
              }
            />
            <Route
              path='registersetting/*'
              element={
                <SuspensedView>
                  <RegisterSettingPage />
                </SuspensedView>
              }
            />
            <Route
              path='acceptanceletterebys/*'
              element={
                <SuspensedView>
                  <AcceptanceLetterEbysPage />
                </SuspensedView>
              }
            />
          </>
        )}

        <Route
          path='dashboard/*'
          element={
            <SuspensedView>
              <DashboardPage />
            </SuspensedView>
          }
        />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return (
    <Suspense fallback={<TopBarProgress />}>
      <DisableSidebar>{children}</DisableSidebar>
    </Suspense>
  )
}

export {PrivateRoutes}
